var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 19.219,
    cy: 28.107,
    r: 1.445
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.032 5.825v7.398a7.594 7.594 0 01-4.862 7.086l.059 1.866a7.595 7.595 0 014.803 7.063v7.36M13.849 5.864v7.36a7.595 7.595 0 004.803 7.063l.059 1.866a7.595 7.595 0 00-4.862 7.086v7.398M10.915 5.647h21.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.582 32.156h5.853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M32.065 36.912h-21.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkDate);
export default __webpack_public_path__ + "static/media/workDate.0a4412558c16cf2a1be2dbb801ecdc80.svg";
export { ForwardRef as ReactComponent };